<template>
  <div class="container">
    <div class="coupons">
      <div class="coupon" :class="item.types" v-for="(item, index) in coupons" :key="index">
        <div class="coupon-hd">
          <div class="coupon-price" v-if="item.types === 'money_off'">
            <span>{{item.moneyOffAmount}}</span>元
          </div>
          <div class="coupon-price" v-if="item.types === 'discount'">
            <span>{{item.discount / 10}}</span>折
          </div>
          <div class="coupon-info">
            <div class="coupon-info__title van-ellipsis">{{item.title}}</div>
            <div class="coupon-info__desc">指定部分课程使用，详见使用范围</div>
          </div>
        </div>
        <div class="coupon-bd">
          <div class="coupon-expire">{{expireDay(item)}}</div>
          <div class="coupon-range" @click="showRange(item)">使用范围</div>
          <div class="coupon-btn" @click="receive(item.id)">领取</div>
        </div>
      </div>
    </div>
    <Empty :show="coupons.length === 0" text="暂无优惠券" />
    <Service />
    <div class="btns">
      <van-button type="default" round @click="back" class="btn-default">去使用</van-button>
    </div>
    <div class="ft">明明城堡保留最终解释权</div>
    <van-popup class="range-popup" v-model="showRangePopup" :close-on-click-overlay="false">
      <div class="popup">
        <img class="popup-bg" :src="require('@/assets/images/coupon_range_bg.png')" alt="">
        <div class="popup-close" @click="showRangePopup = false"><van-icon name="cross" color="#fff" /></div>
        <div class="popup-title van-ellipsis">{{currentCoupon.title}}</div>
        <div class="popup-content">
          <div class="subject" v-for="(item, index) in currentCoupon.subjects" :key="index" @click="toSubject(item.id)">
            <div class="subject-index">{{index + 1}}</div>
            <div class="subject-name van-ellipsis">{{item.title}}</div>
            <van-icon name="arrow" color="#ff8700" />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Empty from '@/components/Empty'
import Service from '@/components/Service'
import { getActCoupons, getActCoupon } from './query.gql'
export default {
  name: 'couponReceive',
  components: {
    Empty,
    Service
  },
  data() {
    return {
      coupons: [],
      currentCoupon: {},
      showRangePopup: false
    }
  },
  async mounted() {
    await this.weixinAuth()
    this.getCoupons()
    this.wechatShare({
      title: '【限时领取】明明城堡课程优惠',
      imgUrl: 'http://mmcb-pub-static.mmcb.top/coupon-icon.png',
      desc: '开学季，手慢无，精品课程优惠券免费领取',
      link: `${window.location.origin}/#/coupon/receive`
    })
  },
  methods: {
    // 获取用户优惠券
    getCoupons(isAct = true) {
      const self = this
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中'
      })
      self.$apollo.query({
        query: getActCoupons,
        fetchPolicy: 'no-cache',
        variables: { isAct }
      }).then(res => {
        self.coupons = res.data.coupons
        self.$toast.clear()
      }).catch(err => {
        console.error('page：coupon/receive。请求getActCoupons报错', err)
        self.$toast.clear()
        self.$toast.fail('加载数据出错')
      })
    },
    // 领取优惠券
    receive(id) {
      const self = this
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '领取中'
      })
      self.$apollo.query({
        query: getActCoupon,
        fetchPolicy: 'no-cache',
        variables: { id }
      }).then(res => {
        self.$toast.clear()
        if (res.data.getActCoupon.error) {
          self.$toast.fail(res.data.getActCoupon.error)
        } else {
          self.$toast.success('领取成功')
        }
      }).catch(err => {
        console.error('page：coupon/receive。请求getActCoupon报错', err)
        self.$toast.clear()
        self.$toast.fail('领取失败，请重试')
      })
    },
    // 计算有效期
    expireDay(item) {
      let startAt = this.$moment(item.startAt).format('YYYY.MM.DD')
      let endAt = this.$moment(item.endAt).format('YYYY.MM.DD')
      return item.xDays ? `有效期：领取后${item.xDays}天过期` : `有效期：${startAt}-${endAt}`
    },
    // 点击使用范围
    showRange(item) {
      this.currentCoupon = item
      this.showRangePopup = true
    },
    // 跳转到详情页
    toSubject(id) {
      this.$router.push({
        name: 'subject',
        query: { id }
      })
    },
    back() {
      this.$router.push({
        name: 'home'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .coupons{
    padding: 25px 15px 0;
    .coupon{
      border-radius: 6px;
      margin-bottom: 20px;
      overflow: hidden;
      position: relative;
      .coupon-hd{
        display: flex;
        padding: 8px 8px 8px 20px;
        align-items: center;
        .coupon-price{
          color: #ff5825;
          text-shadow: 0px 1px 0px #f00;
          width: 72.5px;
          height: 72.5px;
          line-height: 72.5px;
          border-radius: 50%;
          font-size: 15px;
          font-weight: bold;
          box-sizing: border-box;
          display: flex;
          align-items: baseline;
          justify-content: center;
          background: url('~@/assets/images/available_price_box.png') no-repeat center / 100%;
          span{
            font-size: 45px;
          }
        }
        .coupon-info{
          margin-left: 24px;
          color: #fff;
          .coupon-info__title{
            font-size: 20px;
            font-weight: bold;
            width: 220px;
          }
          .coupon-info__desc{
            font-size: 14px;
            padding-top: 10px;
          }
        }
      }
      .coupon-bd{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 7px 10px;
        .coupon-expire{
          font-size: 11px;
          color: #808080;
        }
        .coupon-range{
          color: #01a2ff;
          font-size: 12px;
          text-decoration: underline;
        }
        .coupon-btn{
          width: 70px;
          height: 25px;
          line-height: 25px;
          border-radius: 15px;
          color: #fff;
          font-size: 15px;
          text-align: center;
          background: #ff6701;
          text-shadow: 2px 2px 4px #ff3d01;
        }
      }
      .coupon-expire__icon{
        width: 63px;
        height: 63px;
        position: absolute;
        bottom: 5px;
        right: 10px;
        img{
          width: 100%;
          display: block;
        }
      }
      &.discount{
        box-shadow: 1px 0px 13px 4px #f5faff;
        .coupon-hd{
          background: url('~@/assets/images/coupon_bg_3.png') no-repeat center / 100%;
          .coupon-info{
            text-shadow: 2px 2px 0px #4191fe;
          }
        }
      }
      &.money_off{
        box-shadow: 1px 0px 13px 4px #fbeee6;
        .coupon-hd{
          background: url('~@/assets/images/coupon_bg_1.png') no-repeat center / 100%;
          .coupon-info{
            text-shadow: 2px 2px 0px #ff7a23;
          }
        }
      }
    }
  }
  .range-popup{
    background: none;
    .popup{
      position: relative;
      .popup-bg{
        width: 300px;
      }
      .popup-close{
        position: absolute;
        top: 12px;
        right: 12px;
        z-index: 9;
      }
      .popup-title{
        position: absolute;
        left: 30px;
        right: 30px;
        top: 17px;
        font-size: 29px;
        font-weight: bold;
        text-align: center;
        color: #fff;
        text-shadow: 4px 1px 1px #ff8216;
        z-index: 7;
      }
      .popup-content{
        border-radius: 15px;
        background: #fff;
        overflow: auto;
        position: absolute;
        top: 87.5px;
        left: 15px;
        right: 15px;
        bottom: 50px;
        z-index: 8;
        padding: 10px 12px;
        .subject{
          display: flex;
          align-items: center;
          .subject-index{
            width: 18px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            border-radius: 9px;
            font-size: 15px;
            font-weight: bold;
            color: #fff;
            background: #ff8700;
            margin-right: 7px;
          }
          .subject-name{
            height: 38.5px;
            line-height: 38.5px;
            font-size: 14px;
            color: #333;
            flex: 1;
          }
        }
      }
    }
  }
  .btns {
    text-align: center;
    padding: 30px 0;
    .btn-default{
      background: #ff6701;
      color: #fff;
      padding: 0 60px;
    }
  }
  .ft {
    text-align: center;
    color: #999;
    font-size: 12px;
    padding: 10px 0;
  }
</style>
